export default "__VITE_ASSET__5c3a75f5__"